module.exports = __webpack_public_path__ + "img/banner_left.68727bd8.jpg";